// extracted by mini-css-extract-plugin
export var searchHeader = "_2m-0";
export var searchHeaderDark = "_2m-1";